import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type BulletPointProps = {
    className?: string;
};

const BulletPoint: FunctionComponent<BulletPointProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'bullet-point'}
            viewBox="0 0 250 250"
        >
            <path d="M125 249.3C56.4 249.3.7 193.6.7 125S56.4.7 125 .7 249.3 56.4 249.3 125 193.6 249.3 125 249.3zm0-238.6C62 10.7 10.7 62 10.7 125S62 239.3 125 239.3 239.3 188 239.3 125 188 10.7 125 10.7z" />
            <circle cx="124.3" cy="123.7" r="78.3" />
        </svg>
    );
};
export default BulletPoint;
